import * as bpac from './bpac'
import env from '../../../env'

type ProductLabelProps = {
  name: string,
  part: string,
  weight: number,
  expirationDate: string,
  individualUrl: string,
  productNo: string
}

type MinceProductLabelProps = {
  name: string,
  weight: number,
  expirationDate: string,
  productNo: string
}

// b-PAC は document への CustomEvent でブリッジと通信するため、複数の印刷を同時に
// 実行するとイベントリスナーが衝突して結果が混線する。そのため1件ずつ直列に処理する。
type PrintJob = () => Promise<void>

const printQueue: PrintJob[] = []
let isPrinting = false

const enqueuePrintJob = (job: PrintJob) => {
  printQueue.push(job)
  processPrintQueue()
}

const processPrintQueue = async () => {
  if (isPrinting) return
  isPrinting = true
  while (printQueue.length > 0) {
    const job = printQueue.shift()
    if (job) {
      try {
        await job()
      } catch (e) {
        console.log(e)
      }
    }
  }
  isPrinting = false
}

export const printBarcode = async (data: string) => {
  console.log(`data: ${data}`)
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.indexOf("windows nt") !== -1) {
    enqueuePrintJob(() => printBarcodeByWindows(data))
  }
  else if (userAgent.indexOf("android") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else {
    alert("印刷サポート外の環境です")
  }
}

export const printProductLabel = async (params: ProductLabelProps) => {
  console.log(`params: ${JSON.stringify(params)}`)
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.indexOf("windows nt") !== -1) {
    enqueuePrintJob(() => printProductLabelByWindows(params))
  }
  else if (userAgent.indexOf("android") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else {
    alert("印刷サポート外の環境です")
  }
}

const printProductLabelByWindows = async (params: ProductLabelProps) => {
  const { name, part, weight, expirationDate, individualUrl, productNo } = params
  if (!bpac.IsExtensionInstalled()) {
    const agent = window.navigator.userAgent.toLowerCase();
    if (agent.indexOf('edg') !== -1)
      window.open('https://microsoftedge.microsoft.com/addons/detail/brother-bpac-extension/kmopihekhjobijiipnloimfdgjddbnhg', '_blank');
    const ischrome = (agent.indexOf('chrome') !== -1) && (agent.indexOf('opr') === -1)
    if (ischrome)
      window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank');
    return;
  }
  try {
    const barcodeTemplatePath = env('PRODUCT_LABEL_TEMPLATE')
    const objDoc = bpac.IDocument
    const ret = await objDoc.Open(barcodeTemplatePath)
    if (ret) {
      const itemNameObj = await objDoc.GetObject("itemName")
      itemNameObj.Text = name
      const partObj = await objDoc.GetObject("part")
      partObj.Text = `【${part}】`
      const weightObj = await objDoc.GetObject("weight")
      weightObj.Text = `${weight}g`
      const expirationDateObj = await objDoc.GetObject("expirationDate")
      expirationDateObj.Text = expirationDate
      const individualUrlObj = await objDoc.GetObject("individualUrl")
      individualUrlObj.Text = individualUrl
      const productNoObj = await objDoc.GetObject("productNo")
      productNoObj.Text = productNo
      await objDoc.StartPrint("", 0)
      await objDoc.PrintOut(1, 0)
      await objDoc.EndPrint()
    }
    else {
      window.alert("テンプレートがありません")
    }
    await objDoc.Close()
  }
  catch (e) {
    console.log(e)
  }
}

export const printMinceProductLabel = async (params: MinceProductLabelProps) => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.indexOf("windows nt") !== -1) {
    enqueuePrintJob(() => printMinceProductLabelByWindows(params))
  }
  else if (userAgent.indexOf("android") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1) {
    // TODO スキームによってアプリ呼び出し
  }
  else {
    alert("印刷サポート外の環境です")
  }
}

const printMinceProductLabelByWindows = async (params: MinceProductLabelProps) => {
  const { name, weight, expirationDate, productNo } = params
  if (!bpac.IsExtensionInstalled()) {
    const agent = window.navigator.userAgent.toLowerCase();
    if (agent.indexOf('edg') !== -1)
      window.open('https://microsoftedge.microsoft.com/addons/detail/brother-bpac-extension/kmopihekhjobijiipnloimfdgjddbnhg', '_blank');
    const ischrome = (agent.indexOf('chrome') !== -1) && (agent.indexOf('opr') === -1)
    if (ischrome)
      window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank');
    return;
  }
  try {
    const templatePath = env('MINCE_PRODUCT_LABEL_TEMPLATE')
    const objDoc = bpac.IDocument
    const ret = await objDoc.Open(templatePath)
    if (ret) {
      const itemNameObj = await objDoc.GetObject("itemName")
      itemNameObj.Text = name
      const weightObj = await objDoc.GetObject("weight")
      weightObj.Text = `${weight}g`
      const expirationDateObj = await objDoc.GetObject("expirationDate")
      expirationDateObj.Text = expirationDate
      const productNoObj = await objDoc.GetObject("productNo")
      productNoObj.Text = productNo
      await objDoc.StartPrint("", 0)
      await objDoc.PrintOut(1, 0)
      await objDoc.EndPrint()
    }
    else {
      window.alert("テンプレートがありません")
    }
    await objDoc.Close()
  }
  catch (e) {
    console.log(e)
  }
}

const printBarcodeByWindows = async (data: string) => {
  if (!bpac.IsExtensionInstalled()) {
    const agent = window.navigator.userAgent.toLowerCase();
    if (agent.indexOf('edg') !== -1)
      window.open('https://microsoftedge.microsoft.com/addons/detail/brother-bpac-extension/kmopihekhjobijiipnloimfdgjddbnhg', '_blank');
    const ischrome = (agent.indexOf('chrome') !== -1) && (agent.indexOf('opr') === -1)
    if (ischrome)
      window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank');
    return;
  }
  try {
    const barcodeTemplatePath = env('BARCODE_TEMPLATE')
    const objDoc = bpac.IDocument
    const ret = await objDoc.Open(barcodeTemplatePath)
    if (ret) {
      await objDoc.SetBarcodeData(0, data)
      await objDoc.StartPrint("", 0)
      await objDoc.PrintOut(1, 0)
      await objDoc.EndPrint()
    }
    else {
      window.alert("テンプレートがありません")
    }
    await objDoc.Close()
  }
  catch (e) {
    console.log(e)
  }
}
